const shortDate: Intl.DateTimeFormatOptions = {month: 'short', day: 'numeric'};

export const startAndEndTimeFormatter = (isoLocale: string, start: string, end: string): string => {
    const dateTimeStart = new Date(start);
    const dateTimeEnd = new Date(end);
    const timeStart = dateTimeStart.toLocaleString(isoLocale, {hour: 'numeric', minute: 'numeric'});
    let splitStartTimeArray: string[] = [];
    let finalTimeStart = '';
    let finalTimeEnd = '';
    splitStartTimeArray = timeStart.split(' ');

    if (!end) {
        finalTimeStart = `${timeStart}`;
        finalTimeEnd = '';
    } else {
        finalTimeStart = ` ${splitStartTimeArray[0]}`;
        finalTimeEnd = ` ${dateTimeEnd.toLocaleString(isoLocale, {
            hour: 'numeric',
            minute: 'numeric',
            timeZoneName: 'short'
        })}`;
    }

    if (!start) {
        finalTimeStart = '';
        finalTimeEnd = '';
    }

    if (
        dateTimeStart.getTime() &&
        dateTimeEnd.getTime() &&
        dateTimeStart.toLocaleString(isoLocale, shortDate) !==
            dateTimeEnd.toLocaleString(isoLocale, shortDate)
    ) {
        finalTimeEnd = `${dateTimeEnd.toLocaleString(isoLocale, shortDate)}, ${finalTimeEnd}`;
    }

    let finalDateTime = `${dateTimeStart.toLocaleString(isoLocale, shortDate)}, ${finalTimeStart}${
        finalTimeEnd ? ' - ' : ''
    }${finalTimeEnd}`;
    if (finalTimeStart === '' && finalTimeEnd === '') {
        finalDateTime = '';
    }
    return finalDateTime;
};

export function getUnixTimeStampStr(): string {
    const now = Date.now();
    const unix = Math.round(now / 1000);
    return unix.toString();
}
